<script setup>
import { StatusEnum } from "@/utilities/enum";
</script>
<template>
  <v-dialog max-width="500" @click:outside="closeModal">
    <v-card class="h-auto bg-white font-inter">
      <div class="flex items-center flex-col py-5">
        <img
          src="../../../assets/icon/confirm.png"
          alt="img confirm"
          class="w-44 h-auto py-5"
        />
        <h2 class="font-medium text-sm my-1">
          Apakah Anda yakin ingin menyetujui laporan ini?
        </h2>
        <h6 class="font-normal text-xs text-gray-500">
          Report akan segera ditindaklanjuti setelah disetujui.
        </h6>
      </div>
      <div class="flex justify-end items-center gap-2 border-t px-4 pb-4 pt-2">
        <v-btn
          variant="outlined"
          class="capitalize text-xs font-medium border-gray-400 text-gray-700"
          @click="closeModal()"
        >
          Cancel
        </v-btn>
        <v-btn
          variant="outlined"
          class="capitalize text-xs font-medium bg-red-600 text-white"
          @click="actionValidate(StatusEnum.COMPLETED)"
        >
          Setujui
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ApproveModal",
  props: {
    actionValidate: Function,
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>
